import { Skeleton } from "@chakra-ui/react";

function formatValue(value, format) {
  if (value === null || value === undefined) return "—";
  if (format === "currency") {
    return `${Number(value).toLocaleString("ar-SA", {
      maximumFractionDigits: 0,
    })} ر.س`;
  }
  if (format === "decimal") {
    return Number(value).toLocaleString("ar-SA", {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    });
  }
  return Number(value).toLocaleString("ar-SA");
}

const LeaderboardCard = ({
  title,
  subtitle,
  items = [],
  loading,
  valueFormat = "number",
  secondaryFormat = "number",
  secondaryLabel,
  emptyText = "لا توجد بيانات",
}) => {
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-border-muted bg-white p-5 shadow-card dark:border-navy-700 dark:bg-navy-800">
      <div>
        <h3 className="text-base font-semibold text-navy-700 dark:text-white">
          {title}
        </h3>
        {subtitle ? (
          <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
        ) : null}
      </div>
      <ol className="flex flex-col gap-2">
        {loading ? (
          [1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} height="44px" borderRadius="10px" />
          ))
        ) : items.length === 0 ? (
          <li className="rounded-xl border border-dashed border-border bg-surface-muted px-4 py-6 text-center text-sm text-gray-500">
            {emptyText}
          </li>
        ) : (
          items.map((it, idx) => (
            <li
              key={it.userId || idx}
              className="flex items-center justify-between gap-3 rounded-xl bg-surface-muted px-3 py-2 dark:bg-navy-700"
            >
              <div className="flex min-w-0 items-center gap-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-info-100 text-xs font-bold text-info-700">
                  {idx + 1}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-navy-700 dark:text-white">
                    {it.user?.name || "—"}
                  </p>
                  {it.secondaryValue !== undefined && secondaryLabel ? (
                    <p className="truncate text-xs text-gray-500">
                      {formatValue(it.secondaryValue, secondaryFormat)} {secondaryLabel}
                    </p>
                  ) : null}
                </div>
              </div>
              <span className="shrink-0 text-sm font-bold text-navy-700 dark:text-white">
                {formatValue(it.value, valueFormat)}
              </span>
            </li>
          ))
        )}
      </ol>
    </div>
  );
};

export default LeaderboardCard;
